import withCountdownTimer from "../../helpers/countdowntimer";
import withReactiveFields from "../../helpers/reactivefields";
import { USES_ORDER_REFERENCE } from "../../../../charge/flags";
import { withProperties, getValueAtPath } from "../../../../utils";
import getChargeLimit from "../../../../lookup/limit";
import getChargeFee from "../../../../lookup/fee";
import ErrorState from "../../../common/error";
import InfoState from "../../../common/info";
import InitView from "./views/init";
import DetailsView from "./views/details";
import withInputFields from "../../helpers/inputfields";
import { isPlainObject } from "../../../../../support/helpers";
import { CHECKOUT_CLOSE_EVENT } from "../../../helpers/tokens";
import PendingView from "../../common/pending";
import { $successful } from "../..";

const METHOD = 'banktransfer';
const METHOD_NAME = 'Bank Transfer';
const CHARGE_MODE = USES_ORDER_REFERENCE;

const VIEWS = [ InitView, DetailsView ];

let $this;

function mount() {
  return (dispatch) => {
    // Some logic here to determine the view to show instead of
    // always showing the bank (first) view, nd also other stuffs
    // like fee check, limit check, etc.
    getChargeLimit.call(this, () => {
      const VIEW = (
        this.TRANSFER_DETAILS && (DetailsView || (this.TRANSFER_DETAILS = null))
      ) || InitView;

      $this = this;

      VIEW && VIEW.activate(() => {
        VIEW === DetailsView &&
        this.CURRENT_TIME &&
        this.$charge.poll(this.pollConfig);
        this.startListeningForCancellation();
        this.visibilityCheck();
      });
    });

    getChargeFee();
  };
}

// function unmount() {
//   return (dispatch) => {
//     this.$charge.cancel();
//   };
// }

function getChargeData() {
  return ({
    is_bank_transfer: true,
    payment_type: 'banktransfer'
  });
}

function getViewsContext(data, store) {
  const currency = getValueAtPath(data, 'currency') || 'NGN';
  const TIMER_DURATION = ((currency === 'NGN' || currency === 'GHS') ? 5 : 3) * 60; // (3 / 5 minutes)
  const REACTIVE_FIELDS = ['CURRENT_TIME', 'TRANSFER_DETAILS'];
  const $context = withReactiveFields(Object.create(null), ...REACTIVE_FIELDS);
  let listening = false;

  const cancellationListener = () => {
    stopListeningForCancellation();
    nullifyReference()
  }

  const startListeningForCancellation = () => {
    if (listening !== true) {
      addEventListener(CHECKOUT_CLOSE_EVENT, cancellationListener, false);

      listening = true;
    }
  }

  const stopListeningForCancellation = () => {
    if (listening === true) {
      removeEventListener(CHECKOUT_CLOSE_EVENT, cancellationListener, false);

      listening = false
    }
  }

  const nullifyReference = () => {
    let reference = getValueAtPath($context, 'reference') || null;

    if (isPlainObject(reference)) {
      withProperties($context, {
        reference: Object.create(null)
      })
    }
  }

  const visibilityCheck = () => {
    // add a check for payment method and current view
    // document.addEventListener('visibilitychange', handleVisibility, false)
  }

  const handleVisibility = () => {
    if (document.visibilityState === 'hidden') {
      const isBankTransferDetailsView = getValueAtPath($context, 'STATE.view.current') === 'BANK_TRANSFER_DETAILS_VIEW';
      if (isBankTransferDetailsView && $context.CURRENT_TIME !== null && $context.TRANSFER_DETAILS !== null) {
        setTimeout(() =>  $context.dispatch(
          InfoState.actions.updateInfo({ canSwitchDetailsView: true })
        ), 10);

        document.removeEventListener('visibilitychange', void 0, false);
      }
    }
  }

  withInputFields($context, {
    accountnumber: null,
    accountname: null
  })

  $context.$subscribe('TRANSFER_DETAILS', (currentValue, oldValue) => {
    setTimeout(() => {
      if (!(oldValue || oldValue === currentValue) && currentValue) {
        DetailsView && DetailsView.activate(() => {
          if (currency === 'NGN' || currency === 'GHS') {
            // Begin polling immediately once the Charge API returns a 200
            // (TRANSFER_DETAILS set) instead of waiting for the customer to
            // confirm the transfer or for a fixed delay to elapse.
            const currentPaymentMethod = getValueAtPath($context, 'STATE.method.current')
            if (currentPaymentMethod === 'banktransfer') {
              $this.$charge.poll($this.pollConfig);
            }
          }
        });
      }
    }, 0);
  });

  withProperties($context, {
    TIMER_DURATION,
    startListeningForCancellation,
    stopListeningForCancellation,
    visibilityCheck,
    $resetContext() {
      $context.$inputs.$reset('accountnumber');
      $context.$inputs.$reset('accountname');
  },
    INIT_VIEW: callback => {
      $context.$resetContext(),
      InitView && InitView.activate(callback);
    }
  });

  return withCountdownTimer($context, {
    duration: TIMER_DURATION,
    onTick() { $context.CURRENT_TIME = $context.$timer.current },
    onFinish() {
      if ($context.$charge.cancel() && !$successful) {
        // Update error to indicate bank transfer waiting timeout
          $context.$timer && $context.$timer.clear();
          $context.CURRENT_TIME = null;
          $context.TRANSFER_DETAILS = null;
          $context.$resetContext();
          stopListeningForCancellation()
          // setTimeout(() => { $context.dispatch(
            // ErrorState.actions.updateErrorMessage('TIMED_OUT')
          // );
        // }, 100)
        setTimeout(() => PendingView && PendingView.activate.call($context), 10)
      }
    }
  });
}

export {
  METHOD,
  METHOD_NAME,
  CHARGE_MODE,
  VIEWS,
  mount,
  // unmount,
  getChargeData,
  getViewsContext
}